const State = {
  suppliers: [],
  supplierMaxSortNumber: 0,
  supplierIdNameList: [],
  suggestedReceivingLocationList: [],
  suggestedReceivingLocationMaxSortNumber: 0,
  supplierIdNameAndDescriptionList: []
}

export default State
